/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useState } from 'react';
import { dublicateAlert, errorAlert, messageAlert } from '../Shared';
import { GContextTypes } from '../types';
import { GlobalContext } from '../contexts';
import { Box, TextField } from '@material-ui/core';
import { useLazyQuery } from '@apollo/client';
import { getOperationHritems } from '../graphql';
import PopupLayout from '../pages/main/PopupLayout';
import { Grid } from '@material-ui/core';
import { CalenderLocal } from '../components';
import { successAlert } from '../Shared/helpers';

import { userroles } from '../common';
import HritemsTable from '../Shared/HritemsTable';
import _ from 'lodash';

export const indexTheList = (list: any) => {
  return list.map((item: any, index: any) => {
    return {
      ...item,
      index,
    };
  });
};

const PopupWorkTicket = ({
  open,
  onClose,
  row,
  isNew,
  addAction,
  editAction,
  theme,
  employees,
}: any) => {
  const [saving, setSaving] = useState(false);
  const [alrt, setAlrt] = useState({ show: false, msg: '', type: undefined });
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [itemsList, setItemsList] = useState<any>([]);
  const [desc, setDesc] = useState(null);
  const {
    translate: { words, isRTL },
    store: { user },
  }: GContextTypes = useContext(GlobalContext);

  const [getItems, itemsData]: any = useLazyQuery(getOperationHritems, {
    fetchPolicy: 'cache-and-network',
  });
  useEffect(() => {
    if (row && row._id) {
      const items = itemsData?.data?.['getOperationHritems']?.data || [];

      if (items && items.length > 0) {
        const newitems = items.map((itm: any, index: any) => {
          return {
            index,
            employeeId: itm?.employeeId,
            employeeName: itm?.employeeName,
            employeeNameAr: itm?.employeeNameAr,
            contractId: itm?.contractId,
            contractName: itm?.contractName,
            contractNameAr: itm?.contractNameAr,
            isWorking: itm?.isWorking,
            isAbsent: itm?.isAbsent,
            overtime: itm?.overtime,
            bonos: itm?.bonos,
            deduction: itm?.deduction,
            desc: itm?.desc,
          };
        });

        setItemsList(newitems);
      }
    }
  }, [itemsData]);

  const resetAllForms = () => {
    setItemsList([]);
    setDesc(null);
    setSelectedDate(new Date());
  };

  const resetForNew = () => {
    setItemsList([]);
    setDesc(null);
    setSelectedDate(new Date());
  };
  const editItemInList = (item: any) => {
    const newArray = itemsList.map((it: any) => {
      if (it.employeeId === item.employeeId && it?.index === item?.index) {
        return item;
      } else {
        return it;
      }
    });
    const newlist = indexTheList(newArray);
    setItemsList(newlist);
  };

  const removeItemFromList = (index: any) => {
    const newList = [...itemsList];
    newList.splice(index, 1);
    const indnewlist = indexTheList(newList);
    setItemsList(indnewlist);
  };

  const handleDateChange = (date: any) => {
    if (date) {
      const d = new Date(date);
      setSelectedDate(d);
      fillEmployees();
    }
  };

  useEffect(() => {
    if (row && row._id) {
      getItems({ variables: { opId: row._id } });
      setDesc(row?.desc);
      handleDateChange(row.time);
    }
  }, [row]);

  const fillEmployees = () => {
    const eitems = employees.map((employee: any, index: any) => {
      return {
        index,
        employeeId: employee?._id,
        employeeName: employee?.name,
        employeeNameAr: employee?.nameAr,
        isWorking: true,
        isAbsent: false,
        overtime: 0,
        bonos: 0,
        deduction: 0,
        desc: '',
      };
    });
    setItemsList(eitems);
  };

  useEffect(() => {
    if (isNew) {
      const start = new Date();
      setSelectedDate(start);
      fillEmployees();
    }
  }, [open]);

  const onSubmit = async (stay: any, print: any) => {
    if (!itemsList || itemsList.length === 0) {
      await messageAlert(
        setAlrt,
        isRTL ? `يجب اضافة عنصر واحد  على الأقل` : `You should add min one item`
      );
      return;
    }
    setSaving(true);
    const newList = itemsList;
    const items = JSON.stringify(newList);

    const bonos = _.sumBy(itemsList, 'bonos');

    const overtime = _.sumBy(itemsList, 'overtime');
    const deduction = _.sumBy(itemsList, 'deduction');
    const isWorking =
      itemsList.filter((il: any) => il?.isWorking === true)?.length || 0;
    const isAbsent =
      itemsList.filter((il: any) => il?.isAbsent === true)?.length || 0;

    const variables: any = {
      _id: row && row._id ? row._id : undefined, // is it new or edit
      time: selectedDate,
      items,
      desc,
      bonos,
      overtime,
      deduction,
      isWorking,
      isAbsent,
      userId: user._id,
    };
    const mutate = isNew ? addAction : editAction;

    await apply(mutate, variables, stay, print);
  };
  const apply = async (mutate: any, variables: any, stay: any, print: any) => {
    try {
      await mutate({ variables });
      await successAlert(setAlrt, isRTL);
      setSaving(false);
      if (stay) {
        resetForNew();
      } else {
        onCloseForm();
      }
    } catch (error) {
      onError(error);
      console.log(error);
    }
  };

  const onError = async (error: any) => {
    if (error.message.includes('duplicate')) {
      await dublicateAlert(setAlrt, isRTL);
    } else {
      await errorAlert(setAlrt, isRTL);
      console.log(error);
    }
  };

  const onCloseForm = () => {
    resetAllForms();
    onClose();
  };

  const onHandleSubmit = (print: any) => {
    onSubmit(false, print);
  };
  const onSubmitStay = () => {
    onSubmit(true, false);
  };

  const title = isRTL ? 'بطاقة الحضور' : 'Attendance Ticket';

  return (
    <PopupLayout
      isRTL={isRTL}
      open={open}
      onClose={onCloseForm}
      title={title}
      onSubmit={onHandleSubmit}
      onSubmitStay={isNew ? onSubmitStay : undefined}
      theme={theme}
      alrt={alrt}
      maxWidth="xl"
      canceltitle={isRTL ? 'اغلاق' : 'Close'}
      saving={saving}
      onlyclose={!isNew && !userroles?.sales?.edit}
      mt={0}
      mb={40}
    >
      <Grid container spacing={0}>
        <Grid item xs={12} md={4}>
          <CalenderLocal
            isRTL={isRTL}
            label={words?.time}
            value={selectedDate}
            onChange={handleDateChange}
          ></CalenderLocal>
        </Grid>
        <Grid item xs={12}>
          <Box
            style={{
              backgroundColor: '#f3f3f3',
              padding: 10,
              marginTop: 15,
              marginBottom: 15,
              borderRadius: 10,
            }}
          >
            <Box style={{ marginBottom: 20 }}>
              <HritemsTable
                rows={itemsList}
                editItem={editItemInList}
                removeItem={removeItemFromList}
                isRTL={isRTL}
                words={words}
                user={user}
              ></HritemsTable>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={1}></Grid>
        <Grid item xs={12} md={9}>
          <TextField
            name="desc"
            onChange={(e: any) => setDesc(e.target.value)}
            value={desc}
            label={words.description}
            variant="outlined"
            margin="dense"
            fullWidth
            multiline
            rowsMax={2}
            rows={2}
            style={{ marginTop: 0 }}
          />
        </Grid>
      </Grid>
    </PopupLayout>
  );
};

export default PopupWorkTicket;
